export default {"src":"/_next/static/media/star.9f0afd1b.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};